import type { ClientSuggestionChangeRequest } from '@DigitaleDoerfer/digitale-doerfer-api';
import { useQueryClient } from '@tanstack/react-query';

import { POST_MUTATION_KEYS } from '@/features/api/constants/mutation';
import { useGrapevineSuggestionEventsApi } from '@/features/api/hooks/grapevine-post-events/useGrapevineSuggestionEventsApi';
import { useApiMutation } from '@/features/api/hooks/useApiMutation';
import { invalidatePostCachesForChangedPost } from '@/features/api/utils/postCaches';

export const useChangeSuggestion = () => {
  const queryClient = useQueryClient();
  const api = useGrapevineSuggestionEventsApi();

  return useApiMutation({
    mutationKey: [POST_MUTATION_KEYS.CHANGE],
    mutationFn: (
      clientSuggestionChangeRequest: ClientSuggestionChangeRequest
    ) => api.onSuggestionChangeRequest({ clientSuggestionChangeRequest }),
    onSuccess: ({ post }) =>
      invalidatePostCachesForChangedPost(queryClient, post)
  });
};
